import { useEffect, useState } from 'react';


const data = [
  {
    left: "The purpose of assessment and the expectations of the candidate are clarified.",
    yes1: true,
    yes2: true,
  },
  {
    left: "Assessment plans take into account the form, quality and sources of evidence required (for example performance evidence, knowledge evidence, knowledge testimony, etc.)..",
    yes1: true,
    yes2: false,
  },
  {
    left: "The form and quality of support to be provided to the candidate in preparing for the assessment are established.",
    yes1: false,
    yes2: false,
  },
  {
    left: "The candidate is actively involved in all aspects of the assessment process to ensure that the assessment is fair and transparent. Possible barriers to fair assessment are identified and addressed.",
    yes1: false,
    yes2: false,
  },
  {
    left: " Assessment plans indicate a variety of appropriate assessment methods and instruments to validate diverse types of learning.",
    yes1: false,
    yes2: false,
  },
  {
    left: "The choice of assessment methods is fit for purpose and ensures reliable and valid assessment outcomes..",
    yes1: false,
    yes2: false,
  },
  {
    left: "An appeals process is in place and made known to the candidate.",
    yes1: false,
    yes2: false,
  },
  {
    left: "Assessment instruments and exemplars are developed and moderated in compliance with the ETQA requirements",
    yes1: false,
    yes2: false,
  },
  {
    left: "Assessment reports indicate the assessment plan, the evidence presented, the assessment outcome and recommendations for further action, including additional training and/or re-assessment..",
    yes1: false,
    yes2: false,
  },
  {
    left: "Moderation and review mechanisms are in place, including policies for verification, evaluation and quality assurance of assessments and assessment systems",
    yes1: false,
    yes2: false,
  },

];

export default function Assessment() {
  const [selected, setSelected] = useState({});
  const [percentage, setPercentage] = useState(0);
  const toggleCheck = (rowIndex, colIndex) => {
    setSelected((prev) => ({
      ...prev,
      [`${rowIndex}-${colIndex}`]: !prev[`${rowIndex}-${colIndex}`],
    }));
  };

  useEffect(() => {
    let current = 0;
    const target = 60;
    const interval = setInterval(() => {
      if (current >= target) {
        clearInterval(interval);
      } else {
        current += 1;
        setPercentage(current);
      }
    }, 20); // adjust speed here
  }, []);
  return (
    <div className="w-full mt-10 md:mt-20">
      {/* Score Section */}
      <div className="flex justify-end md:-mb-16 -mb-8">
        <div className="flex md:gap-4 w-full md:w-auto justify-end">
          <div>
            <h1 className="text-[10px] md:text-[28px] font-semibold text-[#979797] text-center tracking-wide">
              Average
            </h1>
            <div className="flex-1 md:w-[200px] w-[60px] bg-[#F3F5F5] flex items-center justify-center md:h-[72px] p-4">
              <h1 className="font-semibold text-[10px] md:text-[28px]">240</h1>
            </div>
          </div>
          <div>
            <h1 className="text-[10px] md:text-[28px] font-semibold text-[#979797] text-center tracking-wide">
              Actual
            </h1>
            <div className="flex-1 md:w-[210px] w-[60px] bg-[#03897B] text-white rounded-r-md flex items-center justify-center md:h-[72px] p-4">
              <h1 className="font-semibold text-[10px] md:text-[28px]">210</h1>
            </div>
          </div>
        </div>
      </div>

      <div>
      <h2 className="text-[10px] md:text-[28px] font-bold text-black mb-2">
        Score
      </h2>
      <p className="text-[8px] md:text-[28px] text-[#979797] font-semibold md:mb-8">
        Assessment completion rate {percentage}%
      </p>
      <div className="flex md:flex-row gap-4 items-center md:-mt-8">
        <div className="w-full md:h-[20px] h-[10px] rounded-[5px] bg-[#F3F5F5] relative overflow-hidden">
          <div
            className="absolute top-0 left-0 h-full bg-[#03897B] rounded-[5px] transition-all duration-700"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
        <div className="flex gap-4 md:w-auto ">
          <div className="flex-1 md:w-[200px] bg-[#F3F5F5] flex items-center justify-center">
            <h1 className="text-[10px] md:text-[28px] font-bold">YES</h1>
          </div>
          <div className="flex-1 w-[80px] md:w-[210px] bg-[#F3F5F5] flex items-center justify-center">
            <h1 className="text-[10px] md:text-[28px] font-bold">YES</h1>
          </div>
        </div>
      </div>
    </div>

      {/* Table Rows */}
      {data.map((item, i) => (
        <div key={i} className="flex w-full mb-4  md:flex-row mt-1">
          {/* Left Text Box */}
          <div className="flex-[3.5] bg-white p-4 md:p-6 text-black text-[6px] md:text-[24px]">
            {item.left}
          </div>

          {/* YES 1 */}
          <div className="flex-[1] md:h-[200px] bg-[#F3F5F5] flex items-center justify-center">
            <button
              onClick={() => toggleCheck(i, 1)}
              className={`
                md:w-[61px] md:h-[61px] w-4 h-4 rounded-full
                ${
                  selected[`${i}-1`]
                    ? "bg-[#03897B] md:border-[10px] border-[3px] border-white"
                    : "bg-transparent md:border-[10px] border-[3px] border-white"
                }
              `}
            />
          </div>

          {/* YES 2 */}
          <div className="flex-[1] md:h-[200px] bg-[#EDF0EF] flex items-center justify-center">
            <button
              onClick={() => toggleCheck(i, 2)}
              className={`
                md:w-[61px] md:h-[61px] w-4 h-4 rounded-full
                ${
                  selected[`${i}-2`]
                    ? "bg-[#03897B] md:border-[10px] border-[3px] border-white"
                    : "bg-transparent md:border-[10px] border-[3px] border-white"
                }
              `}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
